import { render } from "./ProductSellingSettings.vue?vue&type=template&id=34137ad4&scoped=true&ts=true"
import script from "./ProductSellingSettings.vue?vue&type=script&lang=ts"
export * from "./ProductSellingSettings.vue?vue&type=script&lang=ts"

import "./ProductSellingSettings.vue?vue&type=style&index=0&id=34137ad4&scoped=true&lang=scss"

import exportComponent from "/home/ubuntu/buildAgent/work/a701a23a46ecd31f/bookit-pms/Solution/Bookit.BO/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34137ad4"]])

export default __exports__